import { IAppState } from '../../redux';

export const selectPublicationButtonConfig = (state: IAppState) => {
  const { shouldSwitchToSelf, notEnoughMoney } = state.publication;

  return { shouldSwitchToSelf, notEnoughMoney };
};
